import React, {type FC} from 'react';

import {PUBLISHED_PROJECT_NAME} from '../../../../util/constants';
import {useFormatTag} from '../../../../util/gallery';
import {trackBreadcrumbClicked} from '../../../../util/navigation';
import * as links from '../../../../util/urls';
import Breadcrumbs, {type BreadcrumbPart} from '../../../Breadcrumbs';

export type NavBreadcrumbsFCReportProps = {
  entityName: string;
  projectName: string | undefined;
  reportID: string;
  reportName: string;
  galleryTag?: string;
};

export function useNavBreadcrumbsFCReportParts({
  entityName,
  projectName,
  reportID,
  reportName,
  galleryTag,
}: NavBreadcrumbsFCReportProps): BreadcrumbPart[] {
  const formattedGalleryTag = useFormatTag(galleryTag ?? '');

  let parts: BreadcrumbPart[];
  if (galleryTag == null) {
    parts = [];
  } else {
    parts = [
      {label: `Fully Connected`, to: links.reportGallery()},
      {label: formattedGalleryTag, to: links.reportGallery({tag: galleryTag})},
      {
        label: reportName,
        to: `${links.reportView({
          entityName,
          projectName: projectName ?? PUBLISHED_PROJECT_NAME,
          reportID,
          reportName,
        })}${window.location.search}`,
        onClick: () => trackBreadcrumbClicked('Report'),
      },
    ];
  }

  return parts;
}

const NavBreadcrumbsFCReport: FC<NavBreadcrumbsFCReportProps> = params => {
  const parts = useNavBreadcrumbsFCReportParts(params);
  return <Breadcrumbs parts={parts} />;
};

export default NavBreadcrumbsFCReport;
